import React, {Component} from 'react'

import CRUDManagerGenerator from '../generators/CRUDGenerator'
import {checkPermission, MISC_CAN_CREATE_PROJECT_EXPENSE_TYPES, MISC_CAN_EDIT_PROJECT_EXPENSE_TYPES} from "../../../lib/permissions";

const create = {
    table: 'project_expense_types',
    mutationType: 'upsert_',
    schema: {
        title: 'Create Project Expense Type',
        type: 'object',
        required: ['description'],
        properties: {
            description: {type: 'string', title: 'Description'},
            vat_percentage: {type: 'integer', title: 'VAT %'}
        }
    }
}

const update = {
    table: 'project_expense_types',
    mutationType: 'upsert_',
    schema: {
        title: 'Update Project Expense Type',
        type: 'object',
        required: ['description'],
        properties: {
            id: {type: 'integer'},
            description: {type: 'string', title: 'Description'},
            vat_percentage: {type: 'integer', title: 'VAT %'}
        }
    },
    uiSchema: {
        id: {"ui:widget": "hidden"},
    },
}

const read = {
    title: 'Project Expense Types',
    description: 'Project Expense types allow you to categorise expenses associated with users.',
    table: 'project_expense_types',
    fields: ['id', 'description', 'vat_percentage'],
    uniqueKey: 'id',
    columns: [
        {Header: 'ID', accessor: 'id', maxWidth: '100'},
        {Header: 'Desc', accessor: 'description'},
        {Header: 'VAT %', accessor: 'vat_percentage', maxWidth: '100'},
    ]
}

const config = {
    create,
    read,
    update
}


const CRUDManager = CRUDManagerGenerator(config)

class ProjectExpenseTypes extends Component{

    render(){
        return (
            <CRUDManager
                canCreate={checkPermission(MISC_CAN_CREATE_PROJECT_EXPENSE_TYPES)}
                canEdit={checkPermission(MISC_CAN_EDIT_PROJECT_EXPENSE_TYPES)}
            />
        )
    }
}

export default ProjectExpenseTypes